<div class="file-upload-container">
  <input
    type="file"
    #fileInput
    (change)="onFilesSelected($event)"
    [accept]="acceptedFileTypes"
    multiple
    class="hidden" />

  <!--  <div class="preview-list" *ngIf="filePreviews.length > 0">-->
  <!--    <div *ngFor="let preview of filePreviews; let i = index" class="preview-container">-->
  <!--      &lt;!&ndash; Image preview &ndash;&gt;-->
  <!--      <img-->
  <!--        *ngIf="isImage(preview.type)"-->
  <!--        [src]="preview.url"-->
  <!--        [alt]="preview.name"-->
  <!--        class="preview-image"-->
  <!--      />-->

  <!--      &lt;!&ndash; Non-image file preview &ndash;&gt;-->
  <!--      <div *ngIf="!isImage(preview.type)" class="file-info">-->
  <!--        <i [class]="getFileIcon(preview.type)"></i>-->
  <!--        <div class="file-details">-->
  <!--          <span class="file-name">{{ preview.name }}</span>-->
  <!--          <span class="file-size">{{ formatFileSize(preview.size) }}</span>-->
  <!--        </div>-->
  <!--      </div>-->

  <!--      <button-->
  <!--        (click)="removeFile(i)"-->
  <!--        class="remove-button"-->
  <!--        title="Remove file"-->
  <!--      >-->
  <!--        <i class="fas fa-times"></i>-->
  <!--      </button>-->
  <!--    </div>-->
  <!--  </div>-->

  <!--  <div *ngIf="errors.length > 0" class="error-container">-->
  <!--    <div *ngFor="let error of errors" class="error-message">-->
  <!--      {{ error }}-->
  <!--    </div>-->
  <!--  </div>-->
</div>
